import { logger } from "logging";


export const isAndroid = function (UserAgent?: string) {
    try {
      let userAgent = UserAgent || navigator.userAgent || navigator.vendor || window.opera;

      return userAgent.match(/nykaa-android/i);
    } catch (e) {
      return null;
    }
};

export const isIos = function (UserAgent?: string) {
  try {
    let userAgent = UserAgent || navigator.userAgent || navigator.vendor || window.opera;
    return userAgent.match(/nykaa-ios/i);
  } catch (e) {
    return null;
  }
};

export const isAndroidWeb = () => {
  try {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return userAgent.match(/android/i);
  } catch (e) {
    return null;
  }
};

export const isIosWeb = () => {
  try {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return userAgent.match(/Apple|iPad|iPhone|iPod/i);
  } catch (e) {
    return null;
  }
};

export const isMobileApp = (userAgent?: string) => {
  try {
    return isAndroid(userAgent) || isIos(userAgent);
  } catch (error) {
    logger.error(error, "Error while isMobileApp");
    return false;
  }
};
